import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { MarketingCampaignTopContainer } from "@/components/features/marketing/campaign/top/ui";

import { useGetCampaignTopPageParams } from "./_hooks/use-get-campaign-top-page-params";

export const MarketingCampaignTopPage = () => {
	const { hotelID } = useGetCampaignTopPageParams();

	return (
		<PageMeta title="キャンペーンの一覧" url={generatePath(PATHS.HOTEL.MARKETING.CAMPAIGN.TOP, { hotelID })}>
			<MarketingCampaignTopContainer hotelID={hotelID} />
		</PageMeta>
	);
};

MarketingCampaignTopPage.displayName = "MarketingCampaignTopPage";
